//import ExportApi from "services/ExportApi";

const ExportService = {
  exportar: async ({ startDate, endDate, type }) => {
    // Aqui você pode baixar um arquivo ou chamar uma API
    const response = null//await ExportApi.exportar({ startDate, endDate, type });

    // Suponha que a API retorne um blob (arquivo)
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${type}-export-${startDate}-to-${endDate}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  },
};

export default ExportService;
